import { cx } from 'cva';
import { type FunctionComponent } from 'react';
import { useTranslation } from '../../../../../i18n/resources';
import styles from './FooterQuickLinks.module.css';
import { QuickLink } from './QuickLink/QuickLink';

export type FooterQuickLinksProps = {
  className?: string;
};

export const FooterQuickLinks: FunctionComponent<FooterQuickLinksProps> = ({
  className,
}) => {
  const { t } = useTranslation();

  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.title}>{t('footer', 'quick_links_title')}</div>
      <div className={styles.links}>
        <QuickLink
          path={'https://member.medishare.com'}
          title={'Member Center'}
        />
      </div>
    </div>
  );
};
